(function ($) {
    'use strict';

    function toggleFavorite($button) {
        var productId = parseInt($button.attr('data-product'), 10);

        if (!productId || $button.hasClass('is-loading')) {
            return;
        }

        $button.addClass('is-loading').attr('aria-disabled', 'true');

        $.ajax({
            type: 'POST',
            url: '/theme/public/assets/handler/favoriten.handle.php',
            dataType: 'json',
            data: { product: productId }
        }).done(function (response) {
            if (!response || response.success !== true) {
                return;
            }

            $button
                .toggleClass('is-favorite', response.favorite === true)
                .attr('aria-pressed', response.favorite === true ? 'true' : 'false')
                .find('.text')
                .text(response.favorite === true ? 'gemerkt' : 'Merken');

            $('.header-favoriten').toggleClass(
                'has-favorites',
                Array.isArray(response.products) && response.products.length > 0
            );
        }).always(function () {
            $button.removeClass('is-loading').removeAttr('aria-disabled');
        });
    }

    function removeFavorite($button) {
        var productId = parseInt($button.attr('data-product'), 10);

        if (!productId || $button.hasClass('is-loading')) {
            return;
        }

        $button.addClass('is-loading').attr('aria-disabled', 'true');

        $.ajax({
            type: 'POST',
            url: '/theme/public/assets/handler/favoriten.handle.php',
            dataType: 'json',
            data: { product: productId }
        }).done(function (response) {
            if (!response || response.success !== true || response.favorite !== false) {
                return;
            }

            $('.header-favoriten').toggleClass(
                'has-favorites',
                Array.isArray(response.products) && response.products.length > 0
            );

            var $products = $button.closest('section.favoriten-products');
            var $form = $products.next('section.favoriten-form');
            var $text = $products.prev('section.favoriten-text');

            $form.find('input[data-favorite-product-input="' + productId + '"]').remove();
            $button.closest('a[data-favorite-product]').remove();

            if ($products.find('a[data-favorite-product]').length === 0) {
                $products.remove();
                $form.remove();
                $text.html('<p>Es sind noch keine Produkte gemerkt.</p>');
            }
        }).always(function () {
            $button.removeClass('is-loading').removeAttr('aria-disabled');
        });
    }

    $(document).on('click', '.fav[data-product]', function () {
        toggleFavorite($(this));
    });

    $(document).on('keydown', '.fav[data-product]', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            toggleFavorite($(this));
        }
    });

    $(document).on('click', '.remove-favorite[data-product]', function (event) {
        event.preventDefault();
        event.stopPropagation();
        removeFavorite($(this));
    });

    $(document).on('keydown', '.remove-favorite[data-product]', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            event.stopPropagation();
            removeFavorite($(this));
        }
    });
}(jQuery));
